import requests from "./httpServices";
import {showErrorAlert} from "./AlertService";

const CourseServices = {
  courseadd: async (formData) => {
    try {
      const response = await requests.imagepost('/courses/add', formData, {
          'Content-Type': 'multipart/form-data',
      });
      return response;
    } catch (error) {
      showErrorAlert(error); 
      throw error;
    }
  },
  getAllCourses: async (params) => {
    try {
      const response = await requests.get('/courses', { params });
      return response;
    } catch (error) {
      showErrorAlert(error); 
      throw error;
    }
  },
  updateCourse: async (courseId, data) => {
    try {
      const response = await requests.put(`/courses/${courseId}`, data);
      return response;
    } catch (error) {
      showErrorAlert(error); 
      throw error;
    }
  },
  deleteCourse: async (courseId) => {
    try {
      const response = await requests.delete(`/courses/${courseId}`);
      return response;
    } catch (error) {
      showErrorAlert(error); 
      throw error;
    }
  },
  };
  
export default CourseServices;